// extracted by mini-css-extract-plugin
module.exports = {"giftBox":"GiftBox_giftBox__DuIuJ"};